'use client';

import _formatErrorMessage from "@mui/x-internals/formatErrorMessage";
import * as React from 'react';
export const TimelineGridEventRowContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== "production") TimelineGridEventRowContext.displayName = "TimelineGridEventRowContext";
export function useTimelineGridEventRowContext() {
  const context = React.useContext(TimelineGridEventRowContext);
  if (context === undefined) {
    throw new Error(process.env.NODE_ENV !== "production" ? 'MUI X Scheduler: `TimelineGridEventRowContext` is missing. <TimelineGrid.Event /> part must be placed within <TimelineGrid.EventRow />.' : _formatErrorMessage(266));
  }
  return context;
}